// mutations.js

export default {
    updateSitesList(state, sites){
        state.sitesList = sites
    },
    updateCurrentSite(state, site){
        state.currentSite.name = site.name
        state.currentSite.value = site.value
        let currentSite = state.sitesList.find(item=>item.id === site.value)
        console.log('currentSite', currentSite)
        if(currentSite){
            console.log('Пишем ')
            state.timeZone = currentSite.tz
            state.currentSite.lat = currentSite.lat
            state.currentSite.lon = currentSite.lon
            state.currentSite.tz = currentSite.tz
            state.currentSite.id = currentSite.id
            state.currentSite.company_id = currentSite.company_id
        }
    },
};
